import { Stack, Box, SxProps, Theme } from '@mui/material';
import { StyleObj } from '../../../../@types';
import { mergeSx } from '../../../../utils/styles';

const styles: StyleObj = {
  row: {
    p: '10px',
    borderBottom: '1px solid',
    borderColor: 'neutral.700',
    '&:hover': {
      cursor: 'default',
    },
    height: 45,
  },
  label: {
    color: 'neutral.300',
    fontSize: '14px',
  },
  text: {
    fontSize: '14px',
  },
};

interface StyledDetailsRowProps {
  label: string;
  value?: string;
  onRowClick?: () => void;
  sx?: SxProps<Theme>;
}
const StyledDetailsRow = ({ label, value, onRowClick, sx }: StyledDetailsRowProps) => {
  return (
    <Stack
      direction='row'
      onClick={onRowClick}
      sx={mergeSx(
        {
          justifyContent: 'space-between',
        },
        mergeSx(styles.row, sx)
      )}
    >
      <Box component='span' sx={styles.label}>
        {label}
      </Box>
      <Box component='span' sx={styles.text}>
        {value}
      </Box>
    </Stack>
  );
};

export default StyledDetailsRow;
